export default __webpack_public_path__ + "static/media/trademark.33a3758e.svg";